import { TbApps } from 'react-icons/tb';
const TasksIcon = () => <TbApps size={20} />;

export default TasksIcon;
